(function () {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  function trimParam(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  }

  function money(cents) {
    return Number(((Number(cents) || 0) / 100).toFixed(2));
  }

  function currency() {
    return (
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      undefined
    );
  }

  function toItem(item, index) {
    var gaItem = {
      item_id: String(item.product_id || item.id || ''),
      item_name: item.product_title || item.title || '',
      price: money(item.final_price != null ? item.final_price : item.price),
      quantity: item.quantity || 1,
      index: index
    };
    if (item.vendor) gaItem.item_brand = item.vendor;
    if (item.variant_title && item.variant_title !== 'Default Title') {
      gaItem.item_variant = item.variant_title;
    }
    return gaItem;
  }

  function itemsValue(items) {
    return Number(
      items
        .reduce(function (total, item) {
          return total + item.price * item.quantity;
        }, 0)
        .toFixed(2)
    );
  }

  var ctaSelector = [
    '[data-cta]',
    'a.btn',
    'button.btn',
    'input.btn',
    'a.button',
    'button.button',
    'a[class*="__button"]',
    'button[class*="__button"]',
    'a[class*="__cta"]',
    'button[class*="__cta"]',
    'button.add-to-cart',
    'a.add-to-cart'
  ].join(',');

  function isChromeControl(el) {
    if (el.hasAttribute('data-cta')) return false;
    var cls = typeof el.className === 'string' ? el.className : '';
    return /swiper|slider|zoom|play-btn|popup-play|btn--close|btn--search|js-qty|quantity/.test(cls);
  }

  function sectionLocation(el) {
    var explicit = el.getAttribute('data-cta');
    if (explicit) return explicit;
    var section = el.closest('.shopify-section');
    if (!section || !section.id) return 'page';
    return section.id
      .replace(/^shopify-section-/, '')
      .replace(/^(?:template|sections)--\d+__/, '');
  }

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('#CartDrawer .cart__checkout');
    if (checkout) {
      window.gtag('event', 'cart_checkout_click', {
        location: 'slide_cart',
        cta_text: trimParam(checkout.innerText)
      });
    }

    var el = event.target.closest(ctaSelector);
    if (!el || isChromeControl(el)) return;

    var label = el.querySelector('.faq-numbered__question, .lp-atc-btn__label, .subscription__variant-name');
    var text = label ? label.textContent : (el.value || el.innerText || el.getAttribute('aria-label') || '');
    var ctaId = el.getAttribute('data-cta-id') || text;

    window.gtag('event', 'cta_click', {
      cta_text: trimParam(text),
      cta_location: trimParam(sectionLocation(el)),
      cta_id: trimParam(ctaId),
      link_url: trimParam(el.href || el.getAttribute('data-href') || ''),
      landing_page_id: trimParam(window.location.pathname)
    });
  });

  document.addEventListener('drawerOpen.CartDrawer', function () {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var items = (cart.items || []).map(toItem);
        window.gtag('event', 'view_cart', {
          currency: cart.currency || currency(),
          value: money(cart.total_price),
          location: 'slide_cart',
          items: items
        });
      })
      .catch(function () {
        window.gtag('event', 'view_cart', { location: 'slide_cart' });
      });
  });

  document.addEventListener('cart:cross-sell-added', function (event) {
    var data = event.detail || {};
    var source = Array.isArray(data.items) ? data.items : [];
    if (!source.length) return;

    var items = source.map(toItem);
    window.gtag('event', 'cart_cross_sell', {
      currency: currency(),
      value: itemsValue(items),
      location: 'cart_cross_sell',
      items: items
    });
  });
})();
